export default __webpack_public_path__ + "static/media/castle_card_bg2.55ce8108.png";